
import Moneys from "../../../assets/outline/Moneys.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneysIcon({ className, dataTestid = "MoneysIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Moneys data-testid={dataTestid} className={classes} {...rest} />
  );
}
